import React from "react"

import SyringeIcon from "../../../assets/icons/syringe-icon.svg";
import AwardIcon from "../../../assets/icons/award-icon.svg";
import FlaskIcon from "../../../assets/icons/flask-icon.svg";
import classes from "./feature.module.scss";

const Feature = (props) => {
  let icon = null;
  switch(props.icon) {
    case "award":
        icon = <AwardIcon className={classes.Icon} />
        break;
    case "syringe":
        icon = <SyringeIcon className={classes.Icon} />
        break;
    case "flask":
        icon = <FlaskIcon className={classes.Icon} />
        break;
    default:
      return null;
  }

  return (
    <div className={classes.Feature}>
      {icon}
      <p>
        {props.content}
      </p>
    </div>
  )
}

export default Feature
